import {call, put} from 'redux-saga/effects';

import axios from 'axios';
import * as lexActionType from '../actionsType/lexEnrolled.actionType';
import {getBaseUrl} from '../../../core/utility/filter.utility';

function getLexEnrolled(reqObj) {
    // `${getBaseUrl()}/rest/lex/enrollUesrIntoLEX`
    // http://localhost:3001/enroll
    return axios({
        method: 'post',
        url: `${getBaseUrl()}/rest/lp/enrollUesrIntoLP`,
        data: {
            lpId: reqObj.lpId
        }
    });
}


export function* fetchLexErolledSaga(request) {
    try {
        const response = yield call(getLexEnrolled, request.payload);
        const content = response.data.success;
        yield put({
            type: lexActionType.LEX_ENROLLED_SUCCESS,
            payload: content
        });
        yield put({
            type: lexActionType.FETCHING_LEX_ENROLLED,
            payload: false
        });
    } catch (error) {
        yield put({
            type: lexActionType.LEX_ENROLLED_ERROR,
            payload: 'There has been some issue with 3DS Learning Space. Please try after sometime.'
        });
    }
}
